import React from 'react';

const MissionSection = ({ missionData }) => {
    return (
        <section className="mission-section">
            <div className="container">
                <div className="inner-content">
                    <h5>{missionData.subtitle}</h5>
                    <h2>{missionData.heading}</h2>
                    <p>{missionData.description}</p>
                    <div className="p-box">
                        <p>{missionData.note}</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MissionSection;
